import React from 'react';
import { Link, NavLink } from 'react-router-dom';

// Stylesheet
import './style.css'

function Header() {

    return (
        <>
        <header>            
            <nav className="navbar fixed-top navbar-expand-lg navbar-light">
                <Link className="navbar-brand" to="/">Easy Crypto Coins</Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="nav navbar-nav  ml-auto mr-5" id="navbar-nav">
                    <li className="nav-item ">
                      <NavLink className="nav-link tfx-1" to="/">Home <span className="sr-only">(current)</span></NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link tfx-1" to="/ptc-sites">Get Started</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link tfx-1" to="/about">About</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link tfx-1" to="/credits">Credits</NavLink>
                    </li>
                  </ul>
                </div>
              </nav>              
        </header>            
        </>
    );
};

export default Header;
